import styled from 'styled-components'

import { minmedia, maxmedia } from '../../styles/media-queries'
import {
  inputgray,
  white,
  whitegray,
  bordergray,
  gold,
  red,
  blue
} from '../../styles/colors'

export const Row = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background: ${props => (props.currentUser ? whitegray : white)};
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;
  margin-bottom: 0.75rem;
  padding-top: 1rem;

  ${minmedia.medium`
    padding-top: 1.5rem;
  `};
   ${minmedia.large`
    padding: ${props => (props.noPadding ? '0' : '1.25rem 0')};
    margin-bottom: .5rem;
  `};
`

export const Item = styled.div`
  width: 100%;
  padding: 1rem;
  overflow: hidden;
  ${minmedia.medium`
    width: 50%;
    padding-bottom: 1.5rem;
  `}
  ${minmedia.large`
    width: calc(100% / 5 - 80px);
    padding: 1.5rem 0;
    &:first-child {
      padding-left: 1.5rem;
    }
  `}
`

export const Sup = styled.div`
  text-transform: uppercase;
  font-size: 10px;
  color: ${inputgray};
  font-weight: 500;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;

  ${minmedia.medium`
    font-size: 14px;
  `} ${minmedia.large`
    display: none;
  `};
`

export const LinkContainer = styled.div`
  svg {
    transition: all 0.5s;
    width: 1.5rem;
    height: 1.5rem;
    fill: ${gold};
    margin-right: 0.75rem;
  }
  a {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    cursor: pointer;
    &:hover {
      color: ${red};
      svg {
        fill: ${red};
      }
    }
  }
`

export const Messages = styled.div`
  width: calc(100% - 2.5rem);
  border-top: 1px solid ${bordergray};
  padding: 1rem 0;
  margin: 0 1.25rem;
  font-size: 14px;
  span {
    margin-left: 1rem;
  }
  ${maxmedia.medium`
    span {
      width: 100%;
      display: block;
      margin: 0;
      margin-top: 0.25rem
    }
  `}
`

export const Reminder = styled.div`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  background: ${red};
  color: ${white};
  border-radius: 0.25rem;
  margin: 0 0.25rem;
  ${maxmedia.medium} {
    margin: 0.25rem;
  }
`

export const Complaint = Reminder.extend`
  background: ${blue};
`


// WEBPACK FOOTER //
// ./src/components/InvoiceTableRow/styles.js